/* eslint-disable key-spacing */

angular.module('tc.lookup', [])
.directive('tcLookupContainer', function(lookupService, tcConstants, GlobalService,
										$q, $timeout, $window, $document, $mdMedia, $log) {
	return {
		restrict: 'E',
		transclude: true,
		templateUrl: 'template/lookup/lookupContainer.html',
		require: ['?^tcComponent', 'ngModel'],
		scope: {
			dataItem:				'=ngModel',
			classQueryName:			'@tcLookupQuery',
			componentItem:			'@tcLookupComponentItem',
			queryMethodArguments:	'@tcLookupParameters',
			lookupToListbox:		'@tcLookupToListbox',
			brokerMethodName:		'@tcBrokerMethodName',
			dynamicFavourites:		'@tcLookupDynamicfavourites',
			lookupFunction:			'=tcLookupFunction',
			ariaLabel:				'@ariaLabel',
			lookupId:				'@tcLookupId',
			listRowIndex:			'=tcLookupListRowIndex',
			componentForm:			'=tcComponentForm',
			itemChangeHandler:		'&tcItemChangeHandler',
			lookupParamsFunction:	'&tcLookupParamsFunction',
			lookupDisabled:			'=tcLookupDisabled',
			isDateField:			'=tcDateField',
			isValueList:			'=tcLookupValueList',
			tcLookupAllowHtmlMatches: '=tcLookupAllowHtmlMatches',
			tcLookupFilterComponent: '@tcLookupFilterComponent',
			isBarcode: 				'=tcIsBarcode'
		},
		link: function(scope, element, attrs, controllers) {
			var componentCtrl = controllers[0];
			var ngModelCtrl = controllers[1];
			var configuration = {
				lookupKeyCode: tcConstants.KEY_CODE.F6,
			};
			var isTouchDevice = GlobalService.isTouchDevice();
			var userAgent = $window.navigator.userAgent || $window.navigator.vendor || $window.opera;
			var isAndroid = userAgent.match(/android/i);
			var isIos = userAgent.match(/ipad|iphone|ipod/i);
			var componentContext = (componentCtrl ? componentCtrl.componentContext : '');
			var isInsideOverlay = (componentCtrl && angular.isDefined(componentCtrl.options)
				&& (componentCtrl.options.displayMode === tcConstants.COMPONENT_DISPLAY_MODE.OVERLAY));

			// Get lookup configuration from Global Service
			if (angular.isDefined(GlobalService.configuration.lookup)) {
				configuration = GlobalService.configuration.lookup;
			}
			scope.globalStrings = GlobalService.getGlobalStrings();

			// Make the container un-focusable
			element.attr('tabindex', -1);

			// Store a reference to the text input
			var containerElement = element[0].getElementsByTagName('md-input-container')[0];
			var inputElement = containerElement.children[0];
			if (inputElement.tagName === 'DIV') inputElement = inputElement.children[0];
			var inputElementType = '';
			if (angular.isDefined(inputElement)) {
				inputElementType = inputElement.tagName.toLowerCase();
			}
			if (angular.isDefined(scope.lookupToListbox)) inputElementType = 'listbox';
			var validateOnFocusOut = (['tc-html-rich-text','textarea'].indexOf(inputElementType) === -1);

			scope.lookupData = {
				pageNumber:		1,
				activeRowIndex:	undefined,
				rows:			[],
				headers:		[],
				isFilteredSearch:	false
			};

			scope.viewModel = {
				showMatches:	false,
				softwareKeyboardOpen: false,
				brokerOnly: (scope.classQueryName.split(':')[1] === ''),
				isTouchDevice: isTouchDevice,
				isLookupBrokerPending: false, // Used while lookup promise is pending to enable conditional ng-class on input field
				isTabbing: false,
				isEmbeddedLookup: (scope.lookupToListbox === 'embeddedLookup'),
				isRTL: false // Used to add CSS class to align right when reading direction is Right-To-Left (RTL)
			};

			if (angular.isDefined(GlobalService.logonData)) {
				scope.viewModel.isRTL = (GlobalService.logonData.langDirection === tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT);
			}

			// Update the ngModel data item
			var updateDataItem = function(updatedDataItem) {
				ngModelCtrl.$setViewValue(updatedDataItem);
				ngModelCtrl.$commitViewValue();
				ngModelCtrl.$render();
				ngModelCtrl.$setDirty();
				// Reset any server-side messages when a new lookup value is selected
				setInputValidity('serverError', true);
				setInputValidity('serverWarning', true);
				setInputValidity('serverInformation', true);
				setInputValidity('invalid', true);
			};

			// Direct DOM manipulation
			var scrollMatchesIntoViewport = function() {
				var matchesElement = element[0].getElementsByClassName('matches')[0];
				if (angular.isUndefined(matchesElement)) return;
				var bounds = matchesElement.getBoundingClientRect();
				var overlayElement = $window.document.getElementsByClassName('md-panel tcOverlay')[0];
				var bodyElement = (overlayElement ? overlayElement : $window.document.getElementById('tc_Home-misc-body'));
				var bodyRect = bodyElement.getBoundingClientRect();
				var maxWidth = bodyRect.width;
				// Ensure we're thinner than the window
				if (bounds.width > maxWidth) {
					matchesElement.style.maxWidth = maxWidth + 'px';
					matchesElement.style.overflowX = 'hidden';
				}
				var buttonBarHeight = GlobalService.getButtonBarHeight();
				var maxHeight = (bodyRect.top + bodyRect.bottom - buttonBarHeight);
				var isHtmlRichText = (inputElementType === 'tc-html-rich-text');
				var isHtmlTextbox = (inputElementType === 'tc-html-textbox');
				// Allow space for the software keyboard, as iOS browsers do not calculate coordinates correctly
				var softwareKeyboardOffset = 0;
				// On mobile devices, HRT displays software keyboard when opening canned text lookup
				if (isTouchDevice && (scope.viewModel.softwareKeyboardOpen || isHtmlRichText)) {
					softwareKeyboardOffset = 350;
					maxHeight -= softwareKeyboardOffset;
				}
				var inputOrContentEditableElement = (isHtmlTextbox
					?  $window.document.getElementById(scope.lookupId)
					: (isHtmlRichText && inputElement.nextSibling)
						? inputElement.nextSibling
						: inputElement);

				// Ensure we're not under the window
				if (bounds.bottom > maxHeight) {
					// For touch devices, allow more space for displaying the lookup when typing
					// Use offset=200 fudge factor for software keyboard issues on iOS browsers
					var offset = ((softwareKeyboardOffset !== 0) ? (isIos ? 200 : 10) : 0);

					// For HRT: scroll to the matches directly, otherwise lookup will not be in view with a large HRT
					var toggleElement = (isHtmlRichText ? matchesElement : inputOrContentEditableElement);
					GlobalService.scrollElementIntoView(toggleElement, matchesElement, null, offset);
						}
				// Ensure we're not to the right of the window
				if (bounds.right > bodyRect.right) {
					var scrollbarWidth = ($window.innerWidth - $window.document.body.clientWidth);
					var newRightCoordinate = (inputOrContentEditableElement.getBoundingClientRect().right
												- bodyRect.left - maxWidth + 1 + scrollbarWidth);
					matchesElement.style.right = newRightCoordinate + 'px';
				}
				// ...but don't move window too far left either
				if (bounds.left < -5) matchesElement.style.left = '0px';
			};

			// Return a list of matching rows for the lookup, based on lookup configuration and user input
			// We may choose not to use search text, when lookup icon is clicked -- display all results.
			var fetchLookupMatches = function() {
				var promise = $q(function(resolve, reject) {

					var searchText = '';
					if (inputElementType === 'input' || inputElementType === 'listbox') {
						if (scope.lookupData.isFilteredSearch && !isEmpty()) {
							searchText = inputElement.value;
						}
					} else if (inputElementType === 'textarea') {
						// For canned text (i.e textarea), we just pass the code
						var codeWithSlash = getCodeWithSlash();
						var code = codeWithSlash.replace('\\', '');
						searchText = code;
					} else if (inputElementType === 'tc-html-textbox') {
						if (scope.lookupData.isFilteredSearch && !isEmpty()) {
							searchText = scope.dataItem.value;
							searchText = searchText.replace(/<\/?p>|\r?\n|\r/gi, '');
						}
					} else if (inputElementType === 'tc-html-rich-text') {
						searchText = scope.getCannedTextCode();
					}

					// Listboxes override the lookup properties because they can contain ObjectScript expressions
					if (angular.isDefined(scope.dataItem.lookupProperties)) {
						scope.queryMethodArguments = scope.dataItem.lookupProperties;
					}
					var lookupRequestParams;
					// If used outside of tc-component, allow gathering the lookup parameters via a function
					if (Object.prototype.hasOwnProperty.call(attrs, 'tcLookupParamsFunction')) {
						lookupRequestParams = scope.lookupParamsFunction({item: scope.dataItem, searchText: searchText});
					} else {
						// Prepare the request parameters for the lookup query
						lookupRequestParams = lookupService.prepareLookupParams(scope.queryMethodArguments,
							scope.dataItem.id, searchText, componentCtrl, scope.listRowIndex, scope.viewModel.isEmbeddedLookup);
					}
					var dynamicFavourites = '';
					if ((angular.isDefined(scope.dynamicFavourites)) && (scope.dynamicFavourites !== '')) {
						dynamicFavourites = scope.dynamicFavourites.split('^')[0];
					}
					var componentItem = '';
					if (angular.isDefined(scope.componentItem)) componentItem = scope.componentItem;
					// Must be done every time the lookup is opened as the user can rotate the device, affecting screen size
					// Default is 5 rows for smaller screen size or when within an overlay
					var maxRows = ((!isInsideOverlay && $mdMedia('gt-md')) ? 10 : '');
					// when paging, add a flag if the broker match was shown on the first page
					if ((searchText !== '') && (scope.lookupData.pageNumber > 1)
					&& (angular.isDefined(scope.lookupData.hadBrokerShown)) && (scope.lookupData.hadBrokerShown)) {
						lookupRequestParams['TLOOKUPBROKERSHOWN'] = 1;
					}
					// Make the request
					lookupService.lookup(scope.lookupData.pageNumber, scope.classQueryName, lookupRequestParams,
										scope.brokerMethodName, componentContext, dynamicFavourites, componentItem, maxRows)
					.then(function(successData) {
						// Update our scope with the returned lookup data
						angular.extend(scope.lookupData, successData);
						if (scope.lookupData.rows.length) {
							scope.lookupData.activeRowIndex = 0;
						} else {
							scope.lookupData.activeRowIndex = undefined;
						}
						resolve();
					}, function(responseData) {
						scope.lookupData.activeRowIndex = undefined;
						setInputValidity('invalid', false);
						reject(responseData);
					});
				});
				return promise;
			};

			// Trigger the change handler on the component controller
			// When the lookup row is selected, or the value is cleared
			var triggerChangeHandler = function() {
				if (angular.isDefined(scope.dataItem)) {
					scope.itemChangeHandler({item: scope.dataItem, listRowIndex: scope.listRowIndex});
				}
			};

			// Opening and closing
			var isOpen = function() {
				return (scope.viewModel.showMatches);
			};

			var openLookup = function(hasMatches) {
				var promise = $q(function openLookupPromise(resolve) {
					if (isOpen()) {
						$timeout(scrollMatchesIntoViewport);
						resolve();
					} else if (hasMatches) {
						scope.viewModel.showMatches = true;
						// Allow some time for matches content to render before scrolling. Mobile devices need more time for rendering...
						$timeout(scrollMatchesIntoViewport, (isTouchDevice ? 200 : 100));
						resolve();
					} else {
						fetchLookupMatches()
						.then(function afterFetchLookupMatches() {
							scope.viewModel.showMatches = true;
							$timeout(scrollMatchesIntoViewport, (isTouchDevice ? 200 : 100));
							resolve();
						});
					}
				});
				return promise;
			};

			var closeLookup = function(skipChangeHandler) {
				scope.lookupData.activeRowIndex = undefined;
				scope.viewModel.showMatches = false;
				if (!skipChangeHandler) triggerChangeHandler();
				resetPage();
			};

			var toggleLookup = function() {
				if (isInputDisabled()) {
					closeLookup();
					return;
				}
				if (isOpen()) {
					// Mark as invalid where lookup is filtered with no matches, and user closes the lookup via F6
					if ((validateOnFocusOut) && (isFilteredAndNoMatches()) && (!scope.isDateField)) {
						setInputValidity('invalid', false);
					}
					// Only run the change handler for input that allows free text and lookup selection
					var skipChangeHandler = (inputElementType !== 'tc-html-textbox');
					closeLookup(skipChangeHandler);
				} else {
					if ((angular.isDefined(scope.tcLookupFilterComponent)) && (scope.tcLookupFilterComponent !== '')) {
						openFilterComponent();
						return;
					}
					openLookup()
					.then(function() {
						announceSelectedItem(false);
					});
				}
				if (!isTouchDevice) inputElement.focus();
			};

			var openFilterComponent = function() {
				if (!componentCtrl) return;

				var lookupRequestParams = lookupService.prepareLookupParams(scope.queryMethodArguments,
										scope.dataItem.id, inputElement.value, componentCtrl, scope.listRowIndex);
				var filterComponentUrl = ('/Component/' + scope.tcLookupFilterComponent
										+ '?WEBSYS.TCOMPONENT=' + scope.tcLookupFilterComponent
										+ '&LookupItemID=' + encodeURIComponent(scope.dataItem.id)
										+ '&TRELOADJS=' + encodeURIComponent(componentCtrl.componentHtmlName) + '_lookupSetValue()'
										+ '&CONTEXT=K' + encodeURIComponent(scope.classQueryName)
										+ '&CONTEXT2=' + encodeURIComponent(componentContext));

				angular.forEach(lookupRequestParams, function(lookupRequestParamValue, lookupRequestParamKey) {
					filterComponentUrl += ('&' + lookupRequestParamKey + '=' + lookupRequestParamValue);
				});
				filterComponentUrl = GlobalService.maskUrl(filterComponentUrl);
				componentCtrl.openDialog(filterComponentUrl);
				// Clear any partial value so it is not preserved when navigating back
				scope.dataItem.value = '';
			};

			// Paging
			var nextPage = function() {
				if (scope.lookupData.listMoreRows === true) {
					scope.lookupData.pageNumber += 1;
					scope.viewModel.paging = true;
					fetchLookupMatches()
					.then(function() {
						announceSelectedItem();
						$timeout(scrollMatchesIntoViewport);
						scope.viewModel.paging = false;
					});
				}
			};
			var prevPage = function() {
				if (scope.lookupData.pageNumber > 1) {
					scope.lookupData.pageNumber -= 1;
					scope.viewModel.paging = true;
					fetchLookupMatches()
					.then(function() {
						announceSelectedItem();
						$timeout(scrollMatchesIntoViewport);
						scope.viewModel.paging = false;
					});
				}
			};
			var resetPage = function() {
				scope.lookupData.pageNumber = 1;
			};

			// Active Rows
			var hasActiveRow = function() {
				return (angular.isDefined(scope.lookupData.activeRowIndex));
			};
			var setActiveRow = function(rowIndex) {
				scope.lookupData.activeRowIndex = rowIndex;
			};
			var rowIsActive = function(rowIndex) {
				return (scope.lookupData.activeRowIndex === rowIndex);
			};

			// Keyboard functionality
			var handleKeyDown = function($event) {
				// We don't want to listen to keydowns if we're readonly
				// (the browser handles this if ng-disabled is true, but not ng-readonly)
				if (inputElement.getAttribute('readonly') || scope.lookupDisabled) return;
				// Fire keytips when focused in a lookup field
				if ($event.altKey || $event.ctrlKey || $event.metaKey || $event.shiftKey) return;

				if (scope.isBarcode && (tcConstants.BARCODE_END_KEY_CODES.indexOf($event.which) !== -1)
					&& componentCtrl) {
					var parentComponentHtmlName = componentCtrl.componentHtmlName;
					// replace ' ' for the rare case where item name contains a space
					// changes to this line should also be reflected in itemKeyDownHandler in componentCtrl.js
					var barcodeHandler = scope.dataItem.id.replace(' ', '_') + '_BarcodeHandler';
					var currentValue = scope.componentForm[scope.dataItem.id].$viewValue; // ngModel hasn't updated yet (because of the debounce) so pull from the $viewValue
					var barcodeHandlerReturnValue;
					// run barcode handler
					GlobalService.callFunction(
						parentComponentHtmlName,
						barcodeHandler,
						[currentValue, $event.which],
						function(returnValue) { barcodeHandlerReturnValue = returnValue; }
					);
					if (barcodeHandlerReturnValue === false) {
						$event.stopPropagation();
						$event.preventDefault();
						return;
					}
				}

				scope.viewModel.isTabbing = false;
				if ($event.which === configuration.lookupKeyCode) {
					$event.preventDefault(); // prevent F6 moving focus to URL bar (Windows: Chrome and Firefox)
					toggleLookup();
					checkHasSlash();
				} else if ($event.which === tcConstants.KEY_CODE.ENTER) {
					if (hasActiveRow()) {
						if (isOpen()) {
							selectActiveRow();
							$event.preventDefault(); // Prevent accidental form submission
							isEnteringCode = false;
							return;
						} else {
							selectActiveRowBroker();
						}
					} else if (angular.isDefined(scope.componentForm)) {
						// Wait for broker and JS functions to resolve on entering value and quickly pressing Enter
						scope.componentForm.$tcDelayProcessEvent = true;
					}
					focusOutValidateHandler();
				} else if (($event.which === tcConstants.KEY_CODE.UP_ARROW) || ($event.which === tcConstants.KEY_CODE.DOWN_ARROW)) {
					if (!scope.isDateField) $event.stopPropagation(); // Stop additional keyboard listeners from firing
					if (inputElementType === 'textarea' || inputElementType === 'tc-html-rich-text') {
						// For textareas, we don't want to use arrow keys for the lookup unless it's already open
						if (!isOpen()) return;
					}
					$event.preventDefault();
					// will only increment/decrement selected row if lookup is already open
					var lookupOpen = isOpen();

					openLookup()
					.then(function() {
						// Handle initialisation
						if (!hasActiveRow()) {
							scope.lookupData.activeRowIndex = 0;
						} else if (($event.which === tcConstants.KEY_CODE.UP_ARROW) && (lookupOpen)) {
							scope.lookupData.activeRowIndex -= 1;
						} else if (($event.which === tcConstants.KEY_CODE.DOWN_ARROW) && (lookupOpen)) {
							scope.lookupData.activeRowIndex += 1;
						}
						// Handle overflow
						if (scope.lookupData.activeRowIndex >= scope.lookupData.rows.length) {
							scope.lookupData.activeRowIndex = 0;
						} else if (scope.lookupData.activeRowIndex < 0) {
							scope.lookupData.activeRowIndex = scope.lookupData.rows.length - 1;
						}
						announceSelectedItem(lookupOpen);
					});
				} else if (($event.which === tcConstants.KEY_CODE.PAGE_UP) || ($event.which === tcConstants.KEY_CODE.PAGE_DOWN)) {
					if (isOpen()) {
						if ($event.which === tcConstants.KEY_CODE.PAGE_UP) {
							prevPage();
						} else if ($event.which === tcConstants.KEY_CODE.PAGE_DOWN) {
							nextPage();
						}
						$event.stopPropagation(); // Stop additional keyboard listeners from firing
						$event.preventDefault(); // Prevent the default page scroll action
					}
				} else if (($event.which === tcConstants.KEY_CODE.ESCAPE) && isOpen()) {
					if ($event) $event.stopPropagation(); // Prevent overlay from closing
					isEnteringCode = false;
					// Mark as invalid where lookup is filtered with no matches, and user closes the lookup via ESC
					if (validateOnFocusOut && isFilteredAndNoMatches()) {
						setInputValidity('invalid', false);
					}
					// Only run the change handler for input that allows free text and lookup selection
					var skipChangeHandler = (inputElementType !== 'tc-html-textbox');
					closeLookup(skipChangeHandler);
				} else if ((inputElementType === 'textarea') || (inputElementType === 'tc-html-rich-text')) {
					if ($event.which === tcConstants.KEY_CODE.BACK_SLASH) {
						isEnteringCode = true;
					} else if ($event.which === tcConstants.KEY_CODE.SPACE) {
						checkHasSlash();
						if (isEnteringCode) {
							fetchLookupMatches()
							.then(function() {
								selectActiveRowBroker(true);
							});
							isEnteringCode = false;
							closeLookup();
						}
					} else {
						if (inputElementType === 'textarea') {
							if ($event.which === tcConstants.KEY_CODE.TAB) {
								isEnteringCode = false;
								scope.viewModel.isTabbing = true;
								if ((isOpen()) && (hasActiveRow())) {
									selectActiveRow();
								}
								closeLookup();

							} else if (isEnteringCode) {
								// Need to do this next tick, after textarea is updated with new key pressed
								$timeout(function() {
									fetchLookupMatches();
								});
							}
						}
					}
				} else {
					if ($event.which === tcConstants.KEY_CODE.TAB) {
						scope.viewModel.isTabbing = true;
					}
					// Just a normal key press, mark form to process event with delay to wait for broker debounce
					if (angular.isDefined(scope.componentForm)) scope.componentForm.$tcDelayProcessEvent = true;
				}

			};

			var isEnteringCode = false;

			/// on key press, determine if textarea is entering canned-text code (has a '\'+cannedTextCodeStarts then cursor)
			var checkHasSlash = function() {
				if (inputElementType !== 'textarea') return;
				if (isEnteringCode) return;
				if (inputElement.value.indexOf('\\') !== -1) {
					if (getCodeWithSlash() !== '') isEnteringCode = true;
				}
			};

			// Announces visible lookup columns from selected row if screen reader is being used
			var announceSelectedItem = function(isLookupOpen) {
				var rowData = '';
				if (angular.isDefined(scope.lookupData.rows[scope.lookupData.activeRowIndex])) {
					scope.lookupData.rows[scope.lookupData.activeRowIndex].cols.map(function(item) {
						if (!item.hidden) rowData += item.value + ' ';
					});
				}
				if (rowData !== '') {
					// IE11 doest not consistently read first lookup option on open
					var isIE11 = (!!$window.MSInputMethodContext && !!$window.document.documentMode);
					if (isIE11) GlobalService.announce(rowData, 'assertive');

					// Announce navigation if lookup was just opened
					if (isLookupOpen === false) announceNavigation();
				} else {
					GlobalService.announce(scope.globalStrings['XNOMATCHES'], 'assertive');
				}

			};

			var announceNavigation = function() {
				var message = scope.globalStrings['XLOOKUPPAGING'];
				if (scope.lookupData.listMoreRows) GlobalService.announce(message, 'polite');
			};

			var getCursorPosition = function() {
				if ('selectionStart' in inputElement) {
					return inputElement.selectionStart;
				} else if ($document.selection) {
					var selection = $document.selection.createRange();
					var selectionLength = selection.text.length;
					selection.moveStart('character', -inputElement.value.length);
					var position = (selection.text.length - selectionLength);
					return position;
				}
			};
			var setCursorPosition = function(position) {
				if (inputElement.createTextRange) {
					var range = inputElement.createTextRange();
					range.move('character', position);
					range.select();
				} else {
					if (angular.isDefined(inputElement.selectionStart)) {
						inputElement.focus();
						inputElement.setSelectionRange(position, position);
					}
				}
			};
			var resetCursorPosition = function(originalPosition, inputLength, code, description) {
				var newPosition = originalPosition - code.length + description.length;
				if (newPosition != originalPosition) {
					$timeout(function() { setCursorPosition(newPosition); });
				}
			};

			var getCodeWithSlash = function() {
				var code = '';
				var textAreaValue = inputElement.value;
				var position = getCursorPosition(inputElement);
				var lastIndex = textAreaValue.lastIndexOf('\\', position);
				if (lastIndex !== -1) {
					code = textAreaValue.slice(lastIndex, position).replace(/\s+$/, ''); // remove last space following a code
					if (code.indexOf(' ') !== -1) code = ''; // code cannot have space
				}
				return code;
			};

			var isEmpty = function() {
				if (inputElementType === 'listbox') {
					return (inputElement.value === '');
				} else {
					return (angular.isUndefined(scope.dataItem.value)) || (scope.dataItem.value === '');
				}
			};

			var isFilteredAndNoMatches = function() {
				return (!hasActiveRow() && (scope.lookupData.isFilteredSearch) && !isEmpty());
			};

			var setInputValidity = function(validationErrorKey, isValid) {
				if ((scope.componentForm) && (inputElement) && (inputElement.name)) {
					if (angular.isDefined(scope.componentForm[inputElement.name])) {
						scope.componentForm[inputElement.name].$setValidity(validationErrorKey, isValid);
					}

					// Field value is no longer populated by default value expression
					if ((validationErrorKey === 'invalid') && (isValid) && (scope.dataItem.invalidOnLoad)) {
						scope.dataItem.invalidOnLoad = false;
					}
				}
			};

			// React to changes to the input value
			var handleValueChange = function() {
				var brokerOnly = scope.viewModel.brokerOnly;
				if (inputElement.getAttribute('readonly')) {
					// Allow manual 'change' event to trigger broker on read only lookups
					brokerOnly = true;
				} else if (scope.lookupDisabled) {
					triggerChangeHandler();
					return;
				}

				var isLookupOpen = isOpen();
				if (isEmpty()) {
					ngModelCtrl.$setDirty();
					if ((angular.isDefined(ngModelCtrl.$modelValue)) && (angular.isDefined(ngModelCtrl.$modelValue.valueId))) {
						ngModelCtrl.$modelValue.valueId = '';
					}
					setInputValidity('serverError', true);
					setInputValidity('serverWarning', true);
					setInputValidity('serverInformation', true);
					setInputValidity('invalid', true);
					isEnteringCode = false;
					if (isLookupOpen) {
						closeLookup();
					} else {
						triggerChangeHandler();
					}
				} else {
					if ((inputElementType === 'input' || inputElementType === 'listbox'
							|| inputElementType === 'tc-html-textbox') || isEnteringCode) {
						scope.lookupData.isFilteredSearch = true;

						resetPage();

						// While lookup promise pending the input is invalid and
						// the isLookupBrokerPending flag allow activate the ng-class change class used in UI.Material
						scope.viewModel.isLookupBrokerPending = true;

						fetchLookupMatches()
						.then(function handleLookupMatches() {
							$timeout(function() {
								// Execute on next tick, otherwise it is sometimes not applied
								scope.viewModel.isLookupBrokerPending = false;
							});
							if (angular.isDefined(scope.componentForm)) scope.componentForm.$tcDelayProcessEvent = false;
							if ((((inputElementType !== 'input') && (inputElementType !== 'listbox'))
								|| ($window.document.activeElement === inputElement))
								&& (!brokerOnly)) {
								openLookup(true)
								.then(function() {
									announceSelectedItem(isLookupOpen);
								});
							} else {
								if (!scope.lookupData.hasBrokerResult) {
									if (!scope.isDateField) {
										setInputValidity('invalid', false);
									}
								} else {
									setInputValidity('invalid', true);
								}

								// If the lookup was NOT displayed, only allow match from broker
								if (scope.lookupData.hasBrokerResult && hasActiveRow()) {
									selectActiveRow();
								} else if (!scope.isDateField) {
									setInputValidity('invalid', false);
									inputElement.focus();
								}
							}
						}, function handleLookupMatchesError() {
							$timeout(function() {
								scope.viewModel.isLookupBrokerPending = false;
							});
							if (angular.isDefined(scope.componentForm)) scope.componentForm.$tcDelayProcessEvent = false;
						});
					} else if ((inputElementType === 'textarea') && (!isEnteringCode)) {
						// Not ideal - currently triggers after each key press
						triggerChangeHandler();
					}
				}
			};

			// Row selection
			var selectRow = function(row, $event, appendSpace) {
				var updatedDataItem = scope.dataItem;
				var code,description,hasFormattedText,formattedTextID;
				if (inputElementType === 'input') {
					updatedDataItem.value = row.model;
					if (angular.isDefined(scope.dataItem.valueId) && angular.isDefined(row.valueId)) {
						updatedDataItem.valueId = row.valueId;
					}
				} else if (inputElementType === 'listbox') {
					updatedDataItem.input = '';
				} else if (inputElementType === 'textarea') {
					if ($event) $event.stopPropagation(); // Prevent default action on editable lists
					var newValue = '';
					var currentValue = inputElement.value;
					var position = getCursorPosition(inputElement);
					if (angular.isDefined(row.valueId)) {
						if (angular.isDefined(row.colsNamed.Description)) { //epr.CannedText:LookupByCode / Word Result Lookup query
							description = row.colsNamed.Description.value;
							if (description.indexOf(' | ') !== -1) description = description.split(' | ').join('\n');
						}
					}

					var codeWithSlash = getCodeWithSlash();
					code = '';
					if (codeWithSlash !== '') {
						// If we found a code, we replace it for the description
						code = codeWithSlash;
						var lastIndx = currentValue.lastIndexOf('\\', position);
						newValue = currentValue.slice(0, lastIndx) + description + currentValue.slice(lastIndx + code.length);
					} else {
						// Otherwise insert it at the cursor's position
						var before = currentValue.slice(0, position);
						var after = currentValue.slice(position);
						newValue = before + description + after;
					}
					updatedDataItem.value = newValue;
					if (!scope.viewModel.isTabbing) {
						resetCursorPosition(position, currentValue.length, code, description);
					}
					isEnteringCode = false;
				} else if (inputElementType === 'tc-html-textbox') {
					updatedDataItem.value = row.model;
				} else if (inputElementType === 'tc-html-rich-text') {
					code = row.model;
					description = '';
					hasFormattedText = false;
					formattedTextID = '';
					if (angular.isDefined(row.valueId)) {
						if (angular.isDefined(row.colsNamed.Description)) { //epr.CannedText:LookupByCode / Word Result Lookup query
							description = row.colsNamed.Description.value;
							if (description.indexOf(' | ') !== -1) description = description.split(' | ').join('\n');
						}
						if (angular.isDefined(row.colsNamed['Formatted Text'])) {
							hasFormattedText = (row.colsNamed['Formatted Text'].value === '1');
						}
						if (hasFormattedText && angular.isDefined(row.cols[2])) {
							formattedTextID = row.cols[2].value;
						}
					}
					scope.insertCannedText(description, appendSpace, hasFormattedText, formattedTextID);
					updatedDataItem.value = ngModelCtrl.$viewValue;
					isEnteringCode = false;
				}
				if ((angular.isDefined(scope.dynamicFavourites)) && (scope.dynamicFavourites !== '')) {
					// Construct the dynamic favourite data to be picked up in httpDataConfig, in the same format as TC UI
					var dynamicFavouriteArray = scope.dynamicFavourites.split('^')[0].split(':');
					var dynamicFavouriteData = ('COMP_' + dynamicFavouriteArray[0]
												+ ':' + dynamicFavouriteArray[1] + '^');
					if (dynamicFavouriteArray[2] === '*') {
						dynamicFavouriteData += (row.valueId ? row.valueId : '');
					} else {
						dynamicFavouriteArray[2].split('||').forEach(function(id, idIndex) { //eslint-disable-line
							// Get the current values for each ID column
							var column = row.cols[Number(id) - 1];
							if (column) {
								if (idIndex > 0) dynamicFavouriteData += '||';
								dynamicFavouriteData += column.value;
							}
						});
					}
					// Add the component ID
					dynamicFavouriteData += ('^' + scope.dynamicFavourites.split('^')[1]);
					updatedDataItem.dynamicFavouriteData = dynamicFavouriteData;
				}
				updateDataItem(updatedDataItem);
				scope.lookupData.isFilteredSearch = false;
				/*	Use timeout to allow the model/view values to be updated before any
					additional framework functions that may be called in the lookup/lookupselect/change handlers */
				$timeout(function runLookupHandlers() {
					if (angular.isDefined(scope.lookupFunction)) {
						// This variable is defined on the global scope, it is used within lookup functions
						if (angular.isDefined(scope.listRowIndex)) lu_obj = scope.dataItem; //eslint-disable-line
						if (scope.$parent.viewModel && scope.$parent.viewModel.debugMode) debugger; //eslint-disable-line no-debugger
						scope.lookupFunction(row.data, scope.dataItem);
					}
					if (angular.isDefined(scope.lookupToListbox)) {
						addOptionToListbox(row.data, scope.lookupToListbox);
					}
					runLookupSelectListeners(row.data, scope.dataItem);
					if (angular.isDefined(scope.lookupFunction) && angular.isDefined(scope.listRowIndex)) {
						lu_obj = undefined; //eslint-disable-line
					}
					closeLookup();
					scope.$broadcast('tcLookupContainer:rowSelected', scope.lookupId);
				});
			};

			var selectActiveRow = function() {
				var activeRowIndex = scope.lookupData.activeRowIndex;
				if (angular.isUndefined(activeRowIndex)) return;
				if (angular.isDefined(scope.lookupData.rows) && angular.isDefined(scope.lookupData.rows[activeRowIndex])) {
					var activeRow = scope.lookupData.rows[activeRowIndex];
					if (angular.isDefined(activeRow) && angular.isDefined(activeRow.model)) {
						selectRow(activeRow);
					}
				}
			};

			var selectActiveRowBroker = function(appendSpace) {
				if (hasActiveRow()) {
					var activeRow = scope.lookupData.rows[scope.lookupData.activeRowIndex];
					if (angular.isDefined(activeRow) && angular.isDefined(activeRow.model)) {
						var code = '';
						if (inputElementType === 'textarea') {
							var codeWithSlash = getCodeWithSlash();
							code = codeWithSlash.replace('\\', '');
						} else if (inputElementType === 'tc-html-rich-text') {
							code = scope.getCannedTextCode();
						}

						// Code is fully matched
						if ((code !== '') && (code.toUpperCase() === activeRow.model.toUpperCase())) {
							selectRow(activeRow, null, appendSpace);
						}
					}
				}
			};

			var runLookupSelectListeners = function(rowData) {
				if ((angular.isDefined(scope.dataItem)) && (angular.isDefined(scope.dataItem.eventListeners))
					&& (angular.isDefined(scope.dataItem.eventListeners['lookupselect']))) {
					scope.dataItem.detail = {'lookupValue': rowData};
					angular.forEach(scope.dataItem.eventListeners['lookupselect'], function(listener) {
						listener(scope.dataItem);
					});
					delete scope.dataItem.detail;
				}
			};

			// Add an option to listbox for lookup-to-listbox
			var addOptionToListbox = function(lu, listboxMode) {
				var luArray = lu.split('^');
				var code,desc;
				if (listboxMode == 'embeddedLookup') {
					code = luArray[0];
					desc = luArray[1];
				} else {
					code = luArray[2];
					desc = luArray[0];
				}
				var found = false;
				angular.forEach(scope.dataItem.options, function(option) {
					if (option.caption == desc) found = true;
				});
				if (!found) scope.dataItem.options.push({value: code, caption: desc, selected: true, text: desc});
				// Run validation on chips control
				if ((angular.isDefined(scope.componentForm)) && (angular.isDefined(scope.componentForm[scope.dataItem.id]))) {
					// set dirty - doesn't happen automatically
					scope.componentForm[scope.dataItem.id].$setDirty();

					// reset validity now that value has changed
					scope.componentForm[scope.dataItem.id].$setValidity('serverError', true);
					scope.componentForm[scope.dataItem.id].$setValidity('serverWarning', true);
					scope.componentForm[scope.dataItem.id].$setValidity('serverInformation', true);
					scope.componentForm[scope.dataItem.id].$setValidity('invalid', true);
					scope.componentForm[scope.dataItem.id].$setValidity('invalidListboxOption', true);

					scope.componentForm[scope.dataItem.id].$validate();
				} else if (angular.isUndefined(scope.componentForm)) {
					$log.debug('lookupContainer:addOptionToListbox: scope.componentForm is undefined for ' + scope.dataItem.id,
						' scope= ', scope);
				}
			};

			// Returns if the input field is disabled or read only
			// Can be driven by disabled/readOnly expression in component item option
			var isInputDisabled = function() {
				return (inputElement.getAttribute('disabled') || inputElement.getAttribute('readonly'));
			};

			var reloadValueList = function() {
				var lookupRequestParams;
				// Don't reload value list if item has not yet been tweaked
				if (angular.isUndefined(scope.dataItem.id)) return;
				// Prepare the request parameters for the lookup query
				lookupRequestParams = lookupService.prepareLookupParams(scope.queryMethodArguments,
					scope.dataItem.id, '', componentCtrl, scope.listRowIndex);
				var dynamicFavourites = '';
				var componentItem = '';
				var maxRows = 20; // Magic number of maximum options on a page
				if (angular.isDefined(scope.componentItem)) componentItem = scope.componentItem;
				// Make the request
				lookupService.lookup(scope.lookupData.pageNumber, scope.classQueryName, lookupRequestParams,
									scope.brokerMethodName, componentContext, dynamicFavourites, componentItem, maxRows)
				.then(function(successData) {
					var newValueList = [];
					angular.forEach(successData.rows, function(row) {
						var displayValue = row.model;
						// Chrome issue: need to preserve old array items to correctly indicate current value
						// See https://github.com/angular/material/issues/10546#issuecomment-308409925
						var existingValueIndex = scope.dataItem.valueList.map(function(item) {
							return item.lookupValue;
						}).indexOf(row.data);
						if (existingValueIndex == -1) {
							newValueList.push({value: displayValue,lookupValue: row.data});
						} else {
							newValueList.push(scope.dataItem.valueList[existingValueIndex]);
						}
					});
					scope.dataItem.valueList = newValueList;
					scope.dataItem.hasMoreValues = successData.listMoreRows;
				}, function() {
					setInputValidity('invalid', false);
				});
			};

			// For valueList lookups (with radio buttons) we need to register watchers on dependent parameters
			var initValueListBindings = function() {
				var currentItem = scope.dataItem.id;
				angular.forEach(scope.queryMethodArguments.split(','), function(item) {
					if ((item != currentItem) && componentCtrl
						&& angular.isDefined(componentCtrl.componentItems)
						&& angular.isDefined(componentCtrl.componentItems[item])) {
						scope.$parent.$watch('data.items.' + item + '.value', reloadValueList);
					}
				});
			};

			if (scope.isValueList) {
				initValueListBindings();
			}
			// Emit an event to allow behavior in container directives (e.g. overlay)
			scope.$emit('tcLookupContainer:Init');

			// Public scope properties & methods
			scope.inputElementType = inputElementType;
			scope.isOpen = isOpen;
			scope.openLookup = openLookup;
			scope.closeLookup = closeLookup;
			scope.toggleLookup = toggleLookup;
			scope.isInputDisabled = isInputDisabled;
			scope.openFilterComponent = openFilterComponent;

			scope.nextPage = nextPage;
			scope.prevPage = prevPage;

			scope.hasActiveRow = hasActiveRow;
			scope.setActiveRow = setActiveRow;
			scope.rowIsActive = rowIsActive;
			scope.selectRow = selectRow;
			scope.selectActiveRow = selectActiveRow;

			scope.handleValueChange = handleValueChange;
			scope.handleKeyDown = handleKeyDown;

			scope.$on('tcLookupContainer:changeValue', function(event, obj) {
				if (scope.dataItem.id !== obj.id) return;
				updateDataItem(obj);
				$timeout(handleValueChange);
			});

			scope.$on('tcLookupContainer:toggleLookupDisabled', function(event, obj, disabled) {
				if (scope.dataItem.id !== obj.id) return;
				if (!disabled) {
					$timeout(handleValueChange);
				} else {
					// mark any input as valid when removing lookup
					setInputValidity('invalid', true);
				}
			});

			scope.$on('tcLookupContainer:selectRow', function(event, obj, rowData, $event, appendSpace) {
				if (scope.dataItem.id !== obj.id) return;
				scope.selectRow(rowData, $event, appendSpace);
			});

			// For input elements, validate field when losing focus to prevent submission of invalid values
			var focusOutValidateHandler = function($event) {
				if ($event && $event.relatedTarget) {
					// Prevent closing the lookup when scrolling the main page or overlay via the scrollbar
					if ($event.relatedTarget.classList.contains('mainScreen')) return;
					if ($event.relatedTarget.classList.contains('tcOverlay')) return;
					if (element[0].contains($event.relatedTarget)
						&& (!$event.relatedTarget.classList.contains('matchesBottomMargin'))) {
						return;
					}
				}
				if (hasActiveRow()) {
					if (isOpen()) {
						if (scope.viewModel.isTabbing) {
							selectActiveRow();
						} else if (!scope.viewModel.isLookupBrokerPending) {
							// Force broker to validate when lookup is open and user clicks away
							if (!isEmpty()) $timeout(handleValueChange);
						}
						// Skip running change handler: it is already done by selectActiveRow/handleValueChange
						closeLookup(true);
					} else {
						selectActiveRowBroker();
					}
				} else {
					if (isOpen()) {
						if ((!scope.isDateField) && isFilteredAndNoMatches()) {
							setInputValidity('invalid', false);
							if ($event) $event.preventDefault();
							$timeout(function focusInputElement() {
								inputElement.focus();
							});
						}
						// Only run the change handler for input that allows free text and lookup selection
						var skipChangeHandler = (inputElementType !== 'tc-html-textbox');
						closeLookup(skipChangeHandler);
					}
				}
				scope.viewModel.isTabbing = false;
				isEnteringCode = false;
			};
			if (validateOnFocusOut) {
				element.bind('focusout', focusOutValidateHandler);
			}

			if (isTouchDevice) {
				var resizeHandler = function() {
					scope.viewModel.softwareKeyboardOpen = false;
				};

				// Handle the case where the software keyboard is displayed
				var focusInHandler = function(event) {
					scope.viewModel.softwareKeyboardOpen = (event.target.tagName.toLowerCase() === inputElementType);
					scope.hasFocus = true;

					// Only close when focusing to the actual input element,
					// as the event is also fired when clicking on elements 'within' the directive (matches, paging, etc)
					if (isOpen() && (event.target === inputElement)) {
						closeLookup();
					}

					// On Android, dismissing the software keyboard does not fire 'focusout' - only window 'resize'
					if (isAndroid) angular.element($window).bind('resize', resizeHandler);
				};

				var focusOutHandler = function(event) {
					// When software keyboard is dismissed, scroll screen to display the lookup
					if (scope.viewModel.softwareKeyboardOpen) {
						scope.viewModel.softwareKeyboardOpen = false;
						scope.hasFocus = false;
					}
					// Close lookup on using software keyboard navigation/tabs
					if (isOpen() && (event.target === inputElement)
						&& (!event.relatedTarget || event.relatedTarget.tagName !== 'TC-LOOKUP-CONTAINER')) {
						closeLookup();
					}
					if (isAndroid) angular.element($window).unbind('resize', resizeHandler);
				};

				element.bind('focusin', focusInHandler);
				element.bind('focusout', focusOutHandler);

				var clearField = function($event) {
					if ($event) $event.preventDefault();
					if (inputElementType === 'listbox') {
						inputElement.value = '';
					} else {
						scope.dataItem.value = '';
					}
					updateDataItem(scope.dataItem);
					$timeout(handleValueChange);
				};

				var showQuickDelete = function() {
					return (scope.hasFocus && !isEmpty() && !isInputDisabled());
				};

				scope.showQuickDelete = showQuickDelete;
				scope.clearField = clearField;

				scope.$on('$destroy', function() {
					element.unbind('focusin', focusInHandler);
					element.unbind('focusout', focusOutHandler);
					if (validateOnFocusOut) {
						element.unbind('focusout', focusOutValidateHandler);
					}
					if (isAndroid) angular.element($window).unbind('resize', resizeHandler);
				});
			}
		}
	};
});
